import { isPdiRetailRoutes, isPdiRetailTenant } from "../core/utils"
import { PackServiceContext } from "../digital-journey/ServicePage/context/PackServiceContext"
import { createOrderSimulation } from "../service/createOrder"
import { useContext } from "react"
import { useMutation } from "react-query"
import { useHistory } from "react-router"

export default function useCreateOrder({ tunnelData }) {
  const { tenant } = tunnelData
  const { packContext, selectedPack } = useContext(PackServiceContext)
  const history = useHistory()
  const { location } = history
  const { pathname } = location

  const fillProductsCreateOrder = (basktContent) => {
    if (!basktContent || !basktContent.product) return
    const productsCreateOrder = []
    var delivery
    basktContent.product.forEach(function (p) {
      if (packContext.delivery.value === 712) {
        delivery = "2"
      } else if (packContext.delivery.value === 343) {
        delivery = "1"
      } else {
        delivery = "3"
      }
      const content = {
        deliveryMethod: delivery,
        quantity: 1,
        product: {
          skuDistributor: p.skuDistributor,
          priceIncTaxes: p.priceIncTaxes,
          indicativePublicPriceIncTax: p.indicativePublicPriceIncTax
        }
      }
      productsCreateOrder.push(content)
    })
    return productsCreateOrder
  }

  const hasTunnelData = !!tunnelData
  const hasSelectedPack = !!selectedPack
  const isPackContextFull = !!packContext && !!packContext.packs
  const showBasket = !!tunnelData && isPackContextFull

  const showCreateOrderButton =
    hasTunnelData &&
    hasSelectedPack &&
    isPackContextFull &&
    !!packContext.product &&
    isPdiRetailTenant(tenant) &&
    isPdiRetailRoutes(pathname)

  const { mutate, isLoading } = useMutation(createOrderSimulation, {
    mutationKey: "create-order-simulation",
    retry: false,
    onSuccess: (data) => {
      // Forcer le tenant correct dans l'URL de redirection
      let redirectUrl = data.redirectionUrl

      if (redirectUrl && tenant) {
        // Remplacer le tenant dans l'URL si nécessaire
        const url = new URL(redirectUrl)
        const urlTenant = url.searchParams.get("tenant")

        if (urlTenant !== tenant) {
          console.warn(`⚠️ Tenant mismatch! URL has '${urlTenant}' but should be '${tenant}'`)
          url.searchParams.set("tenant", tenant)
          redirectUrl = url.toString()
        }
      }

      console.log("➡️ Redirecting to:", redirectUrl)
      window.location.href = redirectUrl
    },
    onError: (error) => {
      console.error(error)
    }
  })

  const createOrder = () => {
    if (!tunnelData) return
    if (!selectedPack) return
    if (!packContext) return

    const mutationParams = {
      tunnelData,
      selectedPack,
      basketContent: packContext,
      productsCreateOrder: fillProductsCreateOrder(packContext)
    }
    mutate(mutationParams)
  }

  return {
    createOrder,
    isLoading,
    showBasket,
    showCreateOrderButton
  }
}
